import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { content } from '../data/content';
export function Reviews() {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      const el = carouselRef.current;
      if (!el) return;
      const card = el.children[0] as HTMLElement | undefined;
      const step = card ? card.offsetWidth + 24 : el.clientWidth;
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 8;
      el.scrollTo({
        left: atEnd ? 0 : el.scrollLeft + step,
        behavior: 'smooth'
      });
    }, 4000);
    return () => clearInterval(interval);
  }, [isPaused]);
  return <section id="reviews" className="py-20 md:py-28 bg-white overflow-hidden" data-id="element-181">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-182">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-183">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl font-bold text-brand-brown mb-6" data-id="element-184">
            {content.reviews.heading}
          </motion.h2>
        </div>

        <div className="relative -mx-4 sm:mx-0" data-id="element-185">
          {/* Swipeable Carousel */}
          <div ref={carouselRef} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} onTouchStart={() => setIsPaused(true)} onTouchEnd={() => setIsPaused(false)} className="flex overflow-x-auto snap-x snap-mandatory no-scrollbar pb-12 px-4 sm:px-0 gap-6" style={{
          scrollBehavior: 'smooth'
        }} data-id="element-186">
            {content.reviews.items.map((review, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex-none w-[85vw] sm:w-[400px] snap-center bg-brand-cream rounded-2xl p-8 shadow-lg relative" data-id="element-187">
                <Quote className="absolute top-6 right-6 w-10 h-10 text-brand-tan/20" data-id="element-188" />
                <div className="flex mb-4" data-id="element-189">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-amber text-brand-amber" data-id="element-190" />)}
                </div>
                <p className="text-brand-brown/90 text-lg mb-6 italic leading-relaxed min-h-[120px]" data-id="element-191">
                  "{review.quote}"
                </p>
                <div className="font-display font-bold text-brand-brown text-xl" data-id="element-192">
                  {review.name}
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="text-center mt-4" data-id="element-193">
          <a href="#reviews" className="inline-flex justify-center items-center px-8 py-4 text-lg font-medium rounded border-2 border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-brand-cream transition-all min-h-[48px]" data-id="element-194">
            Read More Reviews
          </a>
        </div>
      </div>
    </section>;
}